import {ConsumerRequest} from '../consumer/consumer-request';

export interface IfsRequest {
  ifs: Ifs;
  ifs2?: Ifs2; //Convenience obj to hold request data in a common spot
  dirs?: Dirs;
  dirsLookup?: DirsLookup;
  dirsEnhanced?: DirsEnhanced;
  hawk?: HawkRequest[];
  hawkSubjects?: HawkSubject[];
  bvs?: Bvs;
  bvss?: Bvss;
  avs?: Avs;
  avss?: Avss;
}

export interface EamlRequest {
  ifsInquiry: IfsRequest;
  consumer: ConsumerRequest;
}

export interface Ifs {
  member?: string;
  branchName?: string;
  userReference?: string;
  productCode?: string;
  lang?: 'EN' | 'FR';
}

export interface Ifs2 {
  name?: string;
  creditCard?: string;
  last4DigitsSin?: string;
  sin?: string;
  sin2?: string;
  dob?: string;
  dob2?: string;
  addresses?: Ifs2Address[];
  phone?: string;
}

export interface Ifs2Address {
  type?: string;
  line1?: string;
  line2?: string;
  line3?: string;
}

export function newIfs2Address(type: string, aptNum: string, civic: string, street: string, city: string, prov: string, postalCode: string, phone: string) {
  return {
    type:  type,
    line1: (aptNum && `${aptNum} - ` || '') + (civic && `${civic} ` || '') + (street || ''),
    line2: (city && `${city}, ` || '') + (prov && `${prov}, ` || '') + (postalCode || ''),
    line3: phone || ''
  };
}

export interface Dirs {
  lastName: string;
  firstName: string;
  middleName: string;
  civic: string;
  street: string;
  apt: string;
  city: string;
  postal: string;
  province: string;
  avsFlag: 'Y' | 'N' | '';
  dirs2Flag: 'Y' | 'N';
}

export interface DirsLookup {
  phone: string;
}

export interface DirsEnhanced extends Dirs, DirsLookup {
}

export interface HawkRequest {
  type: string;
  street: string;
  city: string;
  province: string;
  postal: string;
  phone: string;
}

export interface HawkSubject {
  dob: string;
  sin: string;
}

export interface Bvs {
  firstName: string;
  prov: string;
  lastName: string;
  middleName: string;
  dob: string;
  street: string;
  city: string;
  postal: string;
  phone: string;
}

export interface Bvss {
  sin: string;
}

export interface Avs {
  creditCard: string;
  lastName: string;
  firstName: string;
  street: string;
  city: string;
  prov: string;
  postal: string;
  phone: string;
}

export interface Avss {
  sin: string;
}
